import { createSlice } from '@reduxjs/toolkit'

export const mobileMenuSlice = createSlice({
    name: 'mobileMenu',
    initialState: {
        open: false,
        activeLevel: '1',
        activeSlug: '',
    },
    reducers: {
        open: state => {
            state.open = true
        },
        close: state => {
            state.open = false
        },
        toggle: state => {
            state.open = !state.open
        },
        setActiveLevel: (state, action) => {
            state.activeLevel = action.payload
        },
        setActiveSlug: (state, action) => {
            state.activeSlug = action.payload
        },
    },
})

export const { open, close, toggle, setActiveLevel, setActiveSlug }
    = mobileMenuSlice.actions
export default mobileMenuSlice.reducer
